import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  updateAdminId,
  updateAdminSkip,
  updateAllAdminLimit,
  updateUserDetails,
} from '../../../redux/admin/admin_user/adminSlice';
import {
  DeleteAdmin,
  EditAdmin,
  FetchAdminUsers,
  FetchAdminUsersAdvance,
} from '../../../redux/admin/admin_user/adminServicesSync';
import { format, formatDistanceToNow } from 'date-fns';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import EmptyComponent from '../../../component/EmptyComponent';

const Admin_List = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [deletePayload, setDeletePayload] = useState({});

  const {
    admin_users,
    normalLoading,
    addLoading,
    adminDeleteLoader,
    authSkip,
    authLimit,
    editAdminId,
  } = useSelector((state) => state.admin);

  useEffect(() => {
    dispatch(
      FetchAdminUsers({
        page: authSkip,
        limit: authLimit,
      })
    );

    return () => {
      dispatch(updateAdminSkip(0));

      dispatch(updateAllAdminLimit(10));
    };
  }, [dispatch]);

  const formatLastActivity = (lastActivity) => {
    const lastActivityDate = new Date(lastActivity);
    return formatDistanceToNow(lastActivityDate, { addSuffix: true });
  };

  const handlePageChange = (page) => {
    dispatch(
      FetchAdminUsersAdvance({
        page: page,
        limit: authLimit,
      })
    );
  };

  const handleDeleteUser = async (item) => {
    dispatch(updateAdminId(item?._id));

    dispatch(
      DeleteAdmin({
        ...item,
        id: item?._id,
      })
    );
  };

  const handleEditStatus = (item) => {
    dispatch(updateAdminId(item?._id));

    dispatch(
      EditAdmin({
        ...item,
        status: item?.status === 'active' ? 'inactive' : 'active',
      })
    );
  };

  return (
    <>
      <div class="card overflow-hiddenCoupons">
        <div class="card-header d-flex justify-content-between align-items-center gap-1">
          <h4 class="card-title flex-grow-1">All Admins</h4>

          <NavLink to="/admin_dashboard/create_admins">
            <a class="btn btn-sm btn-primary">Add Admin</a>
          </NavLink>
        </div>

        <div class="card-body p-0">
          {normalLoading ? (
            <TableLoader
              headerArray={[
                'Email',
                'Name',
                'Admin Type',
                'Date',
                'Status',
                'Action',
              ]}
              itemArray={[1, 2, 3, 4, 5, 6]}
            />
          ) : (
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-hover table-centered">
                <thead class="bg-light-subtle">
                  <tr>
                    <th>Email</th>
                    <th>Name</th>
                    <th>Admin Type</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {admin_users?.docs?.length <= 0 ? (
                  <EmptyComponent />
                ) : (
                  <tbody>
                    {admin_users?.docs?.map((item, key) => (
                      <>
                        {item?._id !== editAdminId ? (
                          <tr key={key}>
                            <td>{item?.email}</td>
                            <td>{item?.name}</td>
                            <td>
                              <span class="badge bg-light-subtle text-muted border py-1 px-2">
                                {item?.adminType}
                              </span>
                            </td>
                            <td>
                              {format(new Date(item.createdAt), 'dd MMM yyyy')}
                            </td>
                            <td>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked1"
                                  checked={
                                    item?.status === 'active' ? true : false
                                  }
                                  onChange={(text) => handleEditStatus(item)}
                                />
                              </div>
                            </td>
                            <td>
                              <div class="d-flex gap-2">
                                {/* <a href="#!" class="btn btn-light btn-sm">
                              <iconify-icon
                                icon="solar:eye-broken"
                                class="align-middle fs-18"
                              ></iconify-icon>
                            </a> */}
                                <a
                                  class="btn btn-soft-primary btn-sm"
                                  onClick={() => {
                                    dispatch(updateUserDetails(item));
                                    navigate('/admin_dashboard/edit_admins');
                                  }}
                                >
                                  <iconify-icon
                                    icon="solar:pen-2-broken"
                                    class="align-middle fs-18"
                                  ></iconify-icon>
                                </a>
                                <a
                                  class="btn btn-soft-danger btn-sm"
                                  onClick={() => handleDeleteUser(item)}
                                >
                                  <iconify-icon
                                    icon="solar:trash-bin-minimalistic-2-broken"
                                    class="align-middle fs-18"
                                  ></iconify-icon>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <SingleTableLoader itemArray={[1, 2, 3, 4, 5, 6]} />
                        )}
                      </>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          )}
        </div>
        <div class="row g-0 align-items-center justify-content-between text-center text-sm-start p-3 border-top">
          {/* <div class="col-sm">
            <div class="text-muted">
              Showing <span class="fw-semibold">10</span> of{' '}
              <span class="fw-semibold">59</span> Results
            </div>
          </div>
          <div class="col-sm-auto mt-3 mt-sm-0">
            <ul class="pagination  m-0">
              <li class="page-item">
                <a href="#" class="page-link">
                  <i class="bx bx-left-arrow-alt"></i>
                </a>
              </li>
              <li class="page-item active">
                <a href="#" class="page-link">
                  1
                </a>
              </li>
              <li class="page-item">
                <a href="#" class="page-link">
                  2
                </a>
              </li>
              <li class="page-item">
                <a href="#" class="page-link">
                  3
                </a>
              </li>
              <li class="page-item">
                <a href="#" class="page-link">
                  <i class="bx bx-right-arrow-alt"></i>
                </a>
              </li>
            </ul>
          </div> */}
          <PaginationComponent
            currentPage={admin_users?.page}
            totalItems={admin_users?.totalDocs}
            pageSize={authLimit}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Admin_List;
